export default {
  legalDocumentsDescription: {
    id: 'profile_page_legal_documents_tab_add_legal_documents_description',
    defaultMessage: 'Here’s what you need to add:',
  },
}
